"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n  margin: 6px 0;\n  font-family: ", ";\n  border-radius: 4px;\n  user-select: none;\n  width: 100%;\n  z-index: 99;\n\n  .DayPicker-Months {\n    flex-wrap: nowrap;\n  }\n\n  .DayPicker-Month {\n    margin: 20px 16px 0 16px;\n  }\n\n  .DayPickerInput-Overlay {\n    top: 8px;\n    box-shadow: ", ";\n    border-radius: 4px;\n\n    &:after {\n      content: \"\";\n      height: 100%;\n      position: absolute;\n      width: 2px;\n      height: 100%;\n      left: 50%;\n      top: 0;\n      background-color: #E9E9E9;\n      transform: translateX(-50%);\n    }\n  }\n\n  .DayPickerInput {\n    display: block;\n  }\n\n  .DayPickerInput input {\n    box-sizing: border-box;\n    width: 100%;\n    font-family: ", ";\n    ", ";\n    background: ", ";\n    color: transparent;\n    text-shadow: 0 0 0 ", ";\n    padding: 12px 0 12px 38px;\n    border-image: none;\n    border-style: none;\n    cursor: pointer;\n    &:focus {\n      outline: none;\n    }\n    &::placeholder {\n      font-weight: ", ";\n    }\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  .DayPicker-Day {\n    font-size: 11px;\n    color: ", ";\n    width: 16px;\n    outline: none;\n\n    :hover {\n      color: ", ";\n      background-color: rgba(0, 173, 239, 0.15);\n    }\n  }\n\n  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n    color: ", ";\n    background-color: rgba(0, 173, 239, 0.05);\n    border-radius: 100%;\n\n    :hover {\n      background-color: ", ";\n      color: white;\n    }\n  }\n\n  .DayPicker-Day--today {\n    font-weight: ", ";\n  }\n\n  .DayPicker-Day--start:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n    background-color: ", " !important;\n    color: white !important;\n  }\n\n  .DayPicker-Day--end:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n    background-color: ", " !important;\n    color: white !important;\n  }\n\n  .DayPicker-Caption div {\n    font-size: 11px;\n    margin-bottom: 10px;\n    letter-spacing: 0.9px;\n    text-align: center;\n    text-transform: uppercase;\n    color: ", ";\n  }\n\n  .DayPicker-NavButton {\n    outline: none;\n    color: ", ";\n    top: 1.15rem;\n    background-image: none;\n    border: solid 1px;\n    transform: rotate(45deg);\n    height: 0.5rem;\n    width: 0.5rem;\n  }\n\n  .DayPicker-NavButton--prev {\n    left: 1.5rem;\n    border-right: none;\n    border-top: none;\n  }\n\n  .DayPicker-NavButton--next {\n    border-left: none;\n    border-bottom: none;\n  }\n"], ["\n  margin: 6px 0;\n  font-family: ", ";\n  border-radius: 4px;\n  user-select: none;\n  width: 100%;\n  z-index: 99;\n\n  .DayPicker-Months {\n    flex-wrap: nowrap;\n  }\n\n  .DayPicker-Month {\n    margin: 20px 16px 0 16px;\n  }\n\n  .DayPickerInput-Overlay {\n    top: 8px;\n    box-shadow: ", ";\n    border-radius: 4px;\n\n    &:after {\n      content: \"\";\n      height: 100%;\n      position: absolute;\n      width: 2px;\n      height: 100%;\n      left: 50%;\n      top: 0;\n      background-color: #E9E9E9;\n      transform: translateX(-50%);\n    }\n  }\n\n  .DayPickerInput {\n    display: block;\n  }\n\n  .DayPickerInput input {\n    box-sizing: border-box;\n    width: 100%;\n    font-family: ", ";\n    ", ";\n    background: ", ";\n    color: transparent;\n    text-shadow: 0 0 0 ", ";\n    padding: 12px 0 12px 38px;\n    border-image: none;\n    border-style: none;\n    cursor: pointer;\n    &:focus {\n      outline: none;\n    }\n    &::placeholder {\n      font-weight: ", ";\n    }\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  .DayPicker-Day {\n    font-size: 11px;\n    color: ", ";\n    width: 16px;\n    outline: none;\n\n    :hover {\n      color: ", ";\n      background-color: rgba(0, 173, 239, 0.15);\n    }\n  }\n\n  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n    color: ", ";\n    background-color: rgba(0, 173, 239, 0.05);\n    border-radius: 100%;\n\n    :hover {\n      background-color: ", ";\n      color: white;\n    }\n  }\n\n  .DayPicker-Day--today {\n    font-weight: ", ";\n  }\n\n  .DayPicker-Day--start:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n    background-color: ", " !important;\n    color: white !important;\n  }\n\n  .DayPicker-Day--end:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n    background-color: ", " !important;\n    color: white !important;\n  }\n\n  .DayPicker-Caption div {\n    font-size: 11px;\n    margin-bottom: 10px;\n    letter-spacing: 0.9px;\n    text-align: center;\n    text-transform: uppercase;\n    color: ", ";\n  }\n\n  .DayPicker-NavButton {\n    outline: none;\n    color: ", ";\n    top: 1.15rem;\n    background-image: none;\n    border: solid 1px;\n    transform: rotate(45deg);\n    height: 0.5rem;\n    width: 0.5rem;\n  }\n\n  .DayPicker-NavButton--prev {\n    left: 1.5rem;\n    border-right: none;\n    border-top: none;\n  }\n\n  .DayPicker-NavButton--next {\n    border-left: none;\n    border-bottom: none;\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n"], ["\n  position: relative;\n  display: flex;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  width: 50%;\n  position: relative;\n  .DayPickerInput input {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n\n    &::placeholder {\n      ", "\n    }\n  }\n"], ["\n  width: 50%;\n  position: relative;\n  .DayPickerInput input {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n\n    &::placeholder {\n      ", "\n    }\n  }\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 50%;\n  \n  .DayPickerInput input {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n\n    &::placeholder {\n      ", "\n    }\n  }\n\n  .DayPickerInput-Overlay {\n    margin-left: -100%;\n  }\n"], ["\n  position: relative;\n  width: 50%;\n  \n  .DayPickerInput input {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n\n    &::placeholder {\n      ", "\n    }\n  }\n\n  .DayPickerInput-Overlay {\n    margin-left: -100%;\n  }\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 2px;\n  height: 24px;\n  background-color: ", ";\n  left: 50%;\n  top: 50%;\n\n  transform: translateX(-50%) translateY(-50%);\n"], ["\n  position: absolute;\n  width: 2px;\n  height: 24px;\n  background-color: ", ";\n  left: 50%;\n  top: 50%;\n\n  transform: translateX(-50%) translateY(-50%);\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  pointer-events: none;\n\n  ", ";\n"], ["\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  pointer-events: none;\n\n  ", ";\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  font-size: 11px;\n  padding: 0.5rem;\n  display: table-cell;\n  text-align: center;\n  color: ", ";\n"], ["\n  font-size: 11px;\n  padding: 0.5rem;\n  display: table-cell;\n  text-align: center;\n  color: ", ";\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _DayPickerInput = require("react-day-picker/DayPickerInput");

var _DayPickerInput2 = _interopRequireDefault(_DayPickerInput);

var _moment3 = require("react-day-picker/moment");

require("react-day-picker/lib/style.css");

var _buoyTheme = require("buoy-theme");

var _CalendarIcon = require("./components/CalendarIcon");

var _CalendarIcon2 = _interopRequireDefault(_CalendarIcon);

var _buoyArrow = require("buoy-arrow");

var _buoyArrow2 = _interopRequireDefault(_buoyArrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledContainer = _styledComponents2.default.div.withConfig({
  displayName: "src__StyledContainer",
  componentId: "sc-1p689tz-0"
})(_templateObject, _buoyTheme.fontFamily, _buoyTheme.constants.boxShadow, _buoyTheme.fontFamily, (0, _buoyTheme.fontSize)("bodyMain"), _buoyTheme.colors.neutralLightest, _buoyTheme.colors.neutralDarkest, _buoyTheme.fontWeight.light, _buoyTheme.colors.neutralDarkest, _buoyTheme.colors.primary, _buoyTheme.colors.primary, _buoyTheme.colors.primary, _buoyTheme.fontWeight.normal, _buoyTheme.colors.primary, _buoyTheme.colors.primary, _buoyTheme.colors.neutralDarkest, _buoyTheme.colors.primary);

var StyledInputs = _styledComponents2.default.div.withConfig({
  displayName: "src__StyledInputs",
  componentId: "sc-1p689tz-1"
})(_templateObject2);

var StartDateWrapper = _styledComponents2.default.div.withConfig({
  displayName: "src__StartDateWrapper",
  componentId: "sc-1p689tz-2"
})(_templateObject3, function (props) {
  return props.focused && "font-weight: " + _buoyTheme.fontWeight.regular(props) + ";";
});

var EndDateWrapper = _styledComponents2.default.div.withConfig({
  displayName: "src__EndDateWrapper",
  componentId: "sc-1p689tz-3"
})(_templateObject4, function (props) {
  return props.focused && "font-weight: " + _buoyTheme.fontWeight.regular(props) + ";";
});

var Divider = _styledComponents2.default.div.withConfig({
  displayName: "src__Divider",
  componentId: "sc-1p689tz-4"
})(_templateObject5, _buoyTheme.colors.neutral);

var ArrowWrapper = _styledComponents2.default.div.withConfig({
  displayName: "src__ArrowWrapper",
  componentId: "sc-1p689tz-5"
})(_templateObject6, function (props) {
  return props.up ? "transform: translateY(-50%) rotate(180deg)" : "transform: translateY(-50%)";
});

var WeekdayContainer = _styledComponents2.default.div.withConfig({
  displayName: "src__WeekdayContainer",
  componentId: "sc-1p689tz-6"
})(_templateObject7, _buoyTheme.colors.primary);

var weekdays = ["S", "M", "T", "W", "T", "F", "S"];

var Weekday = function Weekday(_ref) {
  var weekday = _ref.weekday;
  return _react2.default.createElement(
    WeekdayContainer,
    null,
    weekdays[weekday]
  );
};

var DatePicker = function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  /*
   * Adapted from http://react-day-picker.js.org/examples/input-from-to
   */

  function DatePicker(props) {
    _classCallCheck(this, DatePicker);

    var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        from = _this$props.from,
        to = _this$props.to;

    // Ensure from date comes before to date

    if (from && to && to < from) {
      from = undefined;
      to = undefined;
    }

    _this.state = {
      from: from,
      to: to,
      fromFocused: false,
      toFocused: false
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "focusTo",
    value: function focusTo() {
      var _this2 = this;

      // Focus to `to` field. A timeout is required here because the overlays
      // already set timeouts to work well with input fields
      this.timeout = setTimeout(function () {
        return _this2.to.getInput().focus();
      }, 0);
    }
  }, {
    key: "showFromMonth",
    value: function showFromMonth() {
      var _state = this.state,
          from = _state.from,
          to = _state.to;

      if (!from) {
        return;
      }
      if ((0, _moment2.default)(to).diff((0, _moment2.default)(from), 'months') < 2) {
        this.to.getDayPicker().showMonth(from);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state2 = this.state,
          from = _state2.from,
          to = _state2.to,
          fromFocused = _state2.fromFocused,
          toFocused = _state2.toFocused;

      var modifiers = { start: from, end: to };
      return _react2.default.createElement(
        StyledContainer,
        null,
        _react2.default.createElement(
          StyledInputs,
          null,
          _react2.default.createElement(
            StartDateWrapper,
            { focused: fromFocused },
            _react2.default.createElement(_CalendarIcon2.default, null),
            _react2.default.createElement(_DayPickerInput2.default, {
              value: from,
              placeholder: "Start Date",
              format: "ddd M/D",
              formatDate: _moment3.formatDate,
              parseDate: _moment3.parseDate,
              inputProps: {
                onFocus: this.handleFromFocus,
                onBlur: this.handleFromBlur,
                onKeyDown: this.handleKeyDown
              },
              dayPickerProps: {
                weekdayElement: _react2.default.createElement(Weekday, null),
                selectedDays: [from, { from: from, to: to }],
                disabledDays: { after: to },
                toMonth: to,
                modifiers: modifiers,
                numberOfMonths: 2,
                onDayClick: function onDayClick() {
                  return _this3.to.getInput().focus();
                }
              },
              onDayChange: this.handleFromChange
            }),
            _react2.default.createElement(
              ArrowWrapper,
              { up: fromFocused },
              _react2.default.createElement(_buoyArrow2.default, null)
            )
          ),
          _react2.default.createElement(Divider, null),
          _react2.default.createElement(
            EndDateWrapper,
            { focused: toFocused },
            _react2.default.createElement(_CalendarIcon2.default, null),
            _react2.default.createElement(_DayPickerInput2.default, {
              ref: function ref(el) {
                return _this3.to = el;
              },
              value: to,
              placeholder: "End Date",
              format: "ddd M/D",
              formatDate: _moment3.formatDate,
              parseDate: _moment3.parseDate,
              inputProps: {
                onFocus: this.handleToFocus,
                onBlur: this.handleToBlur,
                onKeyDown: this.handleKeyDown
              },
              dayPickerProps: {
                weekdayElement: _react2.default.createElement(Weekday, null),
                selectedDays: [from, { from: from, to: to }],
                disabledDays: { before: from },
                modifiers: modifiers,
                month: from,
                fromMonth: from,
                numberOfMonths: 2
              },
              onDayChange: this.handleToChange
            }),
            _react2.default.createElement(
              ArrowWrapper,
              { up: toFocused },
              _react2.default.createElement(_buoyArrow2.default, null)
            )
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var from = props.from,
          to = props.to;

      // Ensure from date comes before to date

      if (from && to && to < from) {
        from = undefined;
        to = undefined;
      }

      return _extends({}, state, {
        from: from,
        to: to
      });
    }
  }]);

  return DatePicker;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleFromChange = function (from) {
    // Change the from date and focus the "to" input field
    _this4.setState({ from: from });

    var to = _this4.state.to;


    if (_this4.props.onChange) {
      _this4.props.onChange({ from: from, to: to });
    }
  };

  this.handleToChange = function (to) {
    _this4.setState({ to: to }, _this4.showFromMonth);

    var from = _this4.state.from;


    if (_this4.props.onChange) {
      _this4.props.onChange({ from: from, to: to });
    }
  };

  this.handleToFocus = function () {
    _this4.setState({ toFocused: true });
  };

  this.handleToBlur = function () {
    _this4.setState({ toFocused: false });
  };

  this.handleFromFocus = function () {
    _this4.setState({ fromFocused: true });
  };

  this.handleFromBlur = function () {
    _this4.setState({ fromFocused: false });
  };

  this.handleKeyDown = function (e) {

    // This prevents a user from typing anything in the input
    // but still allows clearing with the delete key

    if (e.keyCode !== 8) {
      e.preventDefault();
    }
  };
};

DatePicker.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  to: _propTypes2.default.instanceOf(Date), // Either a Date or null
  from: _propTypes2.default.instanceOf(Date) // Either a Date or null
};

exports.default = DatePicker;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-date-picker/dist/index.js
// module id = 401
// module chunks = 168707334958949